module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "v-checkbox-wrapper",
    style: ({
      'display': _vm.displayType
    })
  }, [_c('span', {
    class: _vm.checkboxClasses
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "v-checkbox-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.label,
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.label) > -1 : (_vm.model)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.label,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model = $$c
        }
      }, _vm.change]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "v-checkbox-inner"
  })]), _vm._v(" "), _c('span', [(_vm.showSlot) ? _vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))]
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16a63d50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-easytable/libs/v-checkbox/src/checkbox.vue
// module id = 1665
// module chunks = 2